export { default as ModalDelete } from './ModalDelete';
export * from './ModalDelete/types';
export { default as ModalDeleteConfirm } from './ModalDeleteConfirm';
export * from './ModalDeleteConfirm/types';
